// Copyright 2020 Sorama B.V.

import { Router } from "aurelia-router";
import { CanvasMediaObjectLinkDTO, LinkedMediaObjectType, SnapshotDTO } from "datatypes/SoramaWebApi";
import { ICanvasMediaObjectLinkRepository } from "repositories/CanvasMediaObjectLinkRepository";
import { BoundingBox, IComposableParent } from "./../ComposableCanvas";
import { ComposableImageMediaObject } from "./ComposableImageMediaObject";
import { IComposableMediaObjectAction } from "./ComposableMediaObject";

export class ComposableSnapshotMediaObject extends ComposableImageMediaObject {
    public readonly additionalActions: IComposableMediaObjectAction[] = [
        { icon: "fas fa-external-link", action: () => this.openSnapshot() },
    ];

    public get mediaObjectType(): LinkedMediaObjectType {
        return LinkedMediaObjectType.Snapshot;
    }

    constructor(
        linkRepository: ICanvasMediaObjectLinkRepository,
        parent: IComposableParent,
        link: CanvasMediaObjectLinkDTO,
        initialSize: BoundingBox,
        source: string | Promise<string>,
        private readonly snapshotObject: SnapshotDTO,
        private readonly router: Router
    ) {
        super(linkRepository, parent, link, initialSize, source, snapshotObject);
    }

    protected openSnapshot(): void {
        this.router.navigate("/Analysis?[timeline]entryId=" + this.snapshotObject.timelineEntryId);
    }
}
